import { GET_ALL_STATICS, GetAllStatics } from "../types/statics";

export const getAllStatics = (): GetAllStatics => {
  return { type: GET_ALL_STATICS, payload: null };
};
